// src/store/user/userSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosInstance from '../../utils/axiosInstance';
import {
  fetchUserDataRequest,
  fetchUserDataSuccess,
  fetchUserDataFailure,
  fetchUserProfilePicRequest,
  fetchUserProfilePicSuccess,
  fetchUserProfilePicFailure,
} from './userSlice';

/** Worker Saga: Fetch user data */
// response.data should be { name, email, profilePic, points, token }
function* handleFetchUserData() {
  try {
    const response = yield call(axiosInstance.get, '/api/auth/user');
    yield put(fetchUserDataSuccess(response.data));
  } catch (error) {
    const errorMsg = error.response?.data || error.message;
    yield put(fetchUserDataFailure(errorMsg));
  }

}

/** Worker Saga: Fetch user profile picture */
// action.payload is the profilePicFilename
function* handleFetchUserProfilePic(action) {
  try {
    const profilePicFilename = action.payload;
    const response = yield call(axiosInstance.get, `/api/images/${profilePicFilename}`, {
      responseType: 'blob',
    });
    const objectUrl = URL.createObjectURL(response.data);
    yield put(fetchUserProfilePicSuccess(objectUrl));
  } catch (error) {
    const errorMsg = error.response?.data || error.message;
    yield put(fetchUserProfilePicFailure(errorMsg));
  }
}

/** Watcher Saga: spawn a new worker on each action */
function* watchUserRequests() {
  yield takeLatest(fetchUserDataRequest, handleFetchUserData);
  yield takeLatest(fetchUserProfilePicRequest, handleFetchUserProfilePic);
}

export default watchUserRequests;




